import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import * as apiUrl from "../../apiUrl"; 
function HomeBanner() {
  const [HomeBanner, setHomeBanner] = useState([]);

  useEffect(() => {
    const fetchHomeBanner = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/home/banner-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setHomeBanner(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchHomeBanner();
  }, []);

  return ( 
      <div className="common-banner-sec banner-video-new-div">
        <video autoPlay muted loop playsInline className="bg-video" poster={`${apiUrl.apiUrl}/${HomeBanner.banner_image}`}>
          {HomeBanner.banner_video && (
            <source
              src={`${apiUrl.apiUrl}/${HomeBanner.banner_video}`}
              type="video/mp4"
            />
          )}
          Your browser does not support the video tag.
        </video>
        {/* <div className="overlay"></div> */}
        <Container fluid>
          <Row className="banner-text-center">
            <Col md={4}> 
            </Col>
          </Row>
        </Container>
      </div> 
  );
}

export default HomeBanner;
